import React from 'react';
import { SearchFilters } from '../../../../types/search';
import { Checkbox } from '../../../common/Checkbox';
import { FILTER_OPTIONS } from '../../../../constants/search';

interface DurationSectionProps {
  draftFilters: SearchFilters;
  onDurationToggle: (duration: string) => void;
  t: (key: string, params?: Record<string, number>) => string;
}

export const DurationSection: React.FC<DurationSectionProps> = ({
  draftFilters,
  onDurationToggle,
  t
}) => {
  const getLabel = (option: typeof FILTER_OPTIONS.DURATION[number]) => {
    if ('max' in option) {
      return t(option.translationKey, { min: option.min, max: option.max });
    }
    return t(option.translationKey, { min: option.min });
  };

  return (
    <div>
      {FILTER_OPTIONS.DURATION.map((option) => (
        <Checkbox
          key={option.value}
          checked={draftFilters.duration === option.value}
          label={getLabel(option)}
          onClick={() => onDurationToggle(option.value)}
          truncate={false}
        />
      ))}
    </div>
  );
}; 